import * as React from 'react';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import { useConsumerMyPageHeader } from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import { usePageHeaderHeight } from 'bundles/composable-page-header/contexts/PageHeaderHeightContext';
import GDPRBanner from 'bundles/user-consent/components/GDPRBanner';

const BANNER_HEIGHT = 68;

// Adapts the legacy GDPRBanner component into the composable page header framework.
const LegacyGDPRBannerWrapper = () => {
  const { enrolledEnterprisePrograms } = useConsumerMyPageHeader();
  const pageHeaderHeightContext = usePageHeaderHeight();

  // In legacy implementations, the GDPRBanner would add a class to the parent element to adjust the height of the page header.
  // In the composable header, we will dynamically set the height of the page header via the PageHeaderHeightContext when either "addParentHeightClass" or "removeParentHeightClass" is called.
  const addHeight = (legacyArg: string) => {
    if (!pageHeaderHeightContext) {
      return;
    }

    pageHeaderHeightContext.setHeight(pageHeaderHeightContext.height + BANNER_HEIGHT);
  };

  const removeHeight = (legacyArg: string) => {
    if (!pageHeaderHeightContext) {
      return;
    }

    pageHeaderHeightContext.setHeight(pageHeaderHeightContext.height - BANNER_HEIGHT);
  };

  return (
    <PageGridContainer>
      <Grid item xs={12}>
        <GDPRBanner
          addParentHeightClass={addHeight}
          removeParentHeightClass={removeHeight}
          // This component just wants to check if a user has any enrolled enterprise programs, it only detects if this array has items.
          programs={enrolledEnterprisePrograms as any}
        />
      </Grid>
    </PageGridContainer>
  );
};

export default LegacyGDPRBannerWrapper;
